import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
export const storedWalletsAtom = atomWithStorage("@arc/sdk/userWallets", [], undefined, {
    getOnInit: true,
});
export const activeWalletIdAtom = atomWithStorage("@arc/sdk/activeUserWalletId", undefined, undefined, { getOnInit: true });
export const activeWalletAtom = atom((get) => {
    const storedWallets = get(storedWalletsAtom);
    const activeWalletId = get(activeWalletIdAtom);
    return storedWallets.find((wallet) => wallet.id === activeWalletId);
});
export const walletsCounterAtom = atomWithStorage("@arc/sdk/walletsCounter", 1, undefined, {
    getOnInit: true,
});
//# sourceMappingURL=keys.js.map